'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosBookmarks = function IoIosBookmarks(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.6 12.9l-1.8 1.2v-9.1h5v9.1l-1.8-1.2-0.7-0.5z m7-7.9c1.5 0 2.6 1 2.6 2.5v22.3c0 1.5-1.1 2.7-2.6 2.7h-11.2s-1.9 0.3-1.9 1.5v1h-1.3v-1c0-1.2-0.9-1.5-1.9-1.5h-11.2c-1.5 0-2.6-1.2-2.6-2.7v-22.3c0-1.5 1.1-2.5 2.6-2.5h11.7s1.4 0.6 1.4 1.2v25.7l0.6 0.4 0.7-0.4v-25.7s0.7-1.2 1.4-1.2h1.7v11.4l3.7-2.5 3.8 2.5v-11.4h2.5z' })
        )
    );
};

exports.default = IoIosBookmarks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-bookmarks.js
// module id = 2572
// module chunks = 168707334958949